// @flow
import * as React from 'react'
import { AppleIcon } from '../../../shared/icons/AppleIcon'
import styled from 'styled-components'
import { SocialButtons } from '@components/shared'
import { useRouter } from 'next/router'

export const APPLE_TEXT = Object.freeze({
  signIn: 'Sign in',
  signUp: 'Sign up',
  continue: 'Continue'
})
export type AppleTextType = $Values<typeof APPLE_TEXT>

export type PropsType = {
  type: AppleTextType,
  disable: boolean,
  isOutlineStyle: boolean,
  socialAuthAgeCheck: (callback: (params?: any) => Promise<void>) => void,
  isSignUp: boolean
}
export type DispatchPropsType = {
  signInWithApple: () => void
}

export default function AppleSignIn (props: PropsType & DispatchPropsType): React.Node {
  const router = useRouter()
  return (
    <SocialButtons
      onClick={(): void => {
        props.socialAuthAgeCheck(async (): Promise<void> => {
          await router.push({
            query: {
              ...router.query,
              socialAuth: 1,
              method: props.isSignUp ? 'signup' : 'signin'
            }
          })
          props.signInWithApple()
        })
      }}
      disable={props.disable}
      isOutlineStyle={props.isOutlineStyle}
    >
      <IconWrapper>
        <AppleIcon color={props.isOutlineStyle ? 'white' : 'black'}/>
      </IconWrapper>
      <ButtonTextSpan>{props.type} with Apple</ButtonTextSpan>
    </SocialButtons>
  )
}

const ButtonTextSpan = styled.span`
  margin-left: 10px;
`
const IconWrapper = styled.div`
  display: flex;
  margin-bottom: 2px;
  width: auto !important;
`
